<div class="genai-models-list-component">
  <div class="grid-view-with-filter-column">
    <div class="filter-column-container">
      <left-column class="col-auto left-column"
        [identifiers]="['filter']"
        [icons]="['filter']"
        #lc>
        @if (lc.show === 'filter' || !lc.show) {
          <filter-column
            [listFilter]=listFilter
            [filterConfig]="filterColumnConfig">
          </filter-column>
        }
      </left-column>
    </div>
    <div class="view-container">
      <div class="filter-tabs-container">
      </div>
      <div class="main-view">
        <div class="grid-card">
          <div class="grid-card-header">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-start scroll-container" style="overflow-x: scroll">
                <filter-tags [filterConfig]="filterColumnConfig" class="d-flex flex-nowrap align-content-center align-items-center flex-grow-1"></filter-tags>
              </div>
              <div class="justify-content-end d-flex flex-row align-items-start ms-2">
                <button type="button"
                  class="btn btn-success btn-sm float-end btn-reload me-2"
                  (click)="getGenAiModels()"
                  [disabled]="loading">
                  <fa-icon [icon]="['fas', 'sync-alt']" [fixedWidth]="true" [animation]="loading ? 'spin' : undefined"></fa-icon>
                </button>
                <filter-sorting [listFilter]="listFilter"
                  [filterConfig]="filterColumnConfig"
                ></filter-sorting>
              </div>
            </div>
          </div>
          <div class="grid-card-body">
            <ng-template #table_headers>
              <thead class="table-dark">
                <tr>
                  <th><div></div></th>
                  <th><div></div></th>
                  <th><div i18n="@@common.name">Name</div></th>
                  <th><div i18n="@@common.identifier">Identifier</div></th>
                  <th><div i18n="@@common.tags" class="justify-content-center">Tags</div></th>
                  <th><div i18n="@@common.ownership">Ownership</div></th>
                  <th><div class="centered" i18n="@@common.live">Live</div></th>
                  <th>
                    <div class="justify-content-end">
                      <fa-icon [icon]="['fas', 'cloud-upload']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                      <span i18n="@@common.created_at">Created at</span>
                    </div>
                  </th>
                  <th>
                    <div class="justify-content-end">
                      <fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                      <span i18n="@@common.updated">Updated</span>
                    </div>
                  </th>
                  <th><div>&nbsp;</div></th>
                </tr>
              </thead>
            </ng-template>
            @if (genAiModels?.getModels().length > 0 && !loading) {
              <div class="table-responsive-new scroll-horizontal has-page-description">
                <table class="table-new vertical-center">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                  <tbody>
                    @for (model of genAiModels?.getModels(); track model.id; let i = $index; let isFirst = $first; let isLast = $last) {
                      <tr
                        dndType="row"
                        [dndDropzone]="['row']"
                        [dndDisableDragIf]="!allowDragging || model.tenant_id !== tenant_id"
                        [dndDisableDropIf]="draggedRowIndex === i"
                        [dndDraggingSourceClass]="'dragged-row-source'"
                        [dndDraggable]="{ identifier: 'draggable', id: model.id, index: i }"
                        [class.above]="i < draggedRowIndex"
                        [class.below]="i > draggedRowIndex"
                        (dndStart)="onRowDragStart(i)"
                        (dndEnd)="onRowDragEnd()"
                        (dndDrop)="onRowDrop($event.data, { identifier: 'dropzone', id: model.id, index: i, rank: model.rank })"
                      >
                        @if (model.tenant_id === tenant_id) {
                          @if (allowDragging) {
                            <td class="cursor-move" dndHandle>
                              <div class="drag-handler">
                                @if ((isFirstPage && !isFirst) || !isFirstPage) {
                                  <span>
                                    <a class="text-decoration-none" (click)="moveModelUp(model, i)" [class.disabled]="!allowMoveByClick">
                                      <fa-icon [icon]="['fas', 'arrow-up']" [fixedWidth]="true" class="pointer"></fa-icon>
                                    </a>
                                  </span>
                                }
                                @if ((isLastPage && !isLast) || !isLastPage) {
                                  <span>
                                    <a class="text-decoration-none" (click)="moveModelDown(model, i)" [class.disabled]="!allowMoveByClick">
                                      <fa-icon [icon]="['fas', 'arrow-down']" [fixedWidth]="true" class="pointer"></fa-icon>
                                    </a>
                                  </span>
                                }
                              </div>
                            </td>
                          } @else {
                            <td></td>
                          }
                        } @else {
                          <td class="text-center">
                            @if (model.platform_default) {
                              <fa-icon
                                [icon]="['fas', 'hand-holding-star']"
                                [fixedWidth]="true"
                                class="primary"
                                i18n-tooltip="@@common.platform_default_model" tooltip="Platform Default Model"
                                container="body">
                              </fa-icon>
                            }
                          </td>
                        }
                        <td class="text-center default-model">
                          <input
                            class="btn-check"
                            type="radio"
                            name="tenant-default-model"
                            autocomplete="off"
                            [value]="model.id"
                            [id]="'tenant-default-model-' + i"
                            [disabled]="disabled() || !model.live"
                            (change)="setTenantDefaultModel(model)"
                          >
                          <label [for]="'tenant-default-model-' + i" class="pointer" [class.disabled]="disabled() || !model.live" [class.is-default-model]="model.tenant_default" [tooltip]="!model.live ? notLiveNonDefaultTenantTooltip : model.tenant_default ? defaultTenantTooltip : nonDefaultTenantTooltip" container="body">
                            <fa-icon [icon]="['fas', model.tenant_default ? 'circle-check' : 'circle']" [fixedWidth]="true" transform="grow-12"></fa-icon>
                          </label>
                        </td>
                        <td>
                          <a [routerLink]="model.tenant_id !== tenant_id ? [model.id, 'detail'] : [model.id, 'edit']">{{ model.name }}</a>
                        </td>
                        <td>
                          <list-data-with-tooltip type="plain_identifier" [shouldTextClip]="true" [model]="model"></list-data-with-tooltip>
                        </td>
                        <td class="text-center">
                          @for (tag of model.tags; track tag) {
                            @if (tag !== 'supported') {
                              <span class="badge rounded-pill text-bg-light me-1">{{ tag }}</span>
                            }
                          }
                        </td>
                        <td class="text-center">
                          @if (model.tenant_id === tenant_id) {
                            <fa-icon
                              [icon]="['fas', 'dot-circle']"
                              [fixedWidth]="true"
                              [class.text-secondary]="model.visibility === 'tenant'"
                              [class.text-body]="model.visibility !== 'tenant'"
                              [tooltip]="visibilityTooltip(model.visibility)"
                              container="body">
                            </fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['fas', 'chart-network']"
                              [fixedWidth]="true"
                              class="text-muted"
                              [tooltip]="visibilityTooltip(model.visibility)"
                              container="body">
                            </fa-icon>
                          }
                        </td>
                        <td>
                          <div class="text-center form-check form-switch d-flex justify-content-center align-items-center">
                            <input class="form-check-input"
                              type="checkbox"
                              autocomplete="off"
                              [id]="'live-switch-' + model.id"
                              [disabled]="genAiModelIsBusy === model.id || model.tenant_id !== tenant_id"
                              [ngModel]="model.live"
                              (ngModelChange)="setLive($event, model)">
                            <label class="form-check-label pointer" [for]="'live-switch-' + model.id"></label>
                          </div>
                        </td>
                        <td class="text-nowrap text-end">
                          <list-data-with-tooltip type="created_at" [model]="model"></list-data-with-tooltip>
                        </td>
                        <td class="text-nowrap text-end">
                          <list-data-with-tooltip [type]="'updated_at'" [model]="model"></list-data-with-tooltip>
                        </td>
                        <td class="text-end align-middle btn-cell">
                          <div class="d-flex justify-content-end">
                            <div class="btn-group me-1">
                              @if (!model.tenant_id || model.tenant_id !== tenant_id) {
                                <button type="button"
                                  class="btn btn-xs btn-dark text-nowrap"
                                  (click)="editGenAiModel(model, $event)"
                                  [routerLink]="[model.id, 'detail']"
                                  container="body"
                                  i18n-tooltip="@@common.details" tooltip="Details"
                                >
                                  <fa-icon [icon]="['fas', 'eye']" [fixedWidth]="true"></fa-icon>
                                </button>
                              } @else {
                                <button type="button"
                                  class="btn btn-xs btn-dark text-nowrap"
                                  (click)="editGenAiModel(model, $event)"
                                  [routerLink]="[model.id, 'edit']"
                                  [disabled]="!model.tenant_id"
                                  container="body"
                                  i18n-tooltip="@@common.edit" tooltip="Edit"
                                >
                                  <fa-icon [icon]="['fas', 'pen']" [fixedWidth]="true"></fa-icon>
                                </button>
                              }
                            </div>
                            <div class="three-dot" dropdown container="body" [isDisabled]="!model.tenant_id || model.tenant_id !== tenant_id">
                              <button type="button"
                                [id]="'button-alignment' + '-' + model.id"
                                class="btn btn-xs btn-dark px-1 dropdown-toggle-single align-self-center"
                                dropdownToggle
                                ><fa-icon [icon]="['fas', 'ellipsis-v']" class="px-0 fa-width-auto"></fa-icon></button>
                                <ul [id]="'button-alignment' + '-' + model.id" *dropdownMenu class="dropdown-menu dropdown-menu-right">
                                  <li role="menuitem">
                                    <a class="dropdown-item pointer text-decoration-none text-danger" (click)="deleteGenAiModel(model)">
                                      <fa-icon [icon]="['fas', 'trash']" [fixedWidth]="true" class="me-1"></fa-icon><ng-container i18n="@@components.gen_ai_models_list.delete">Delete Model</ng-container>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                <div class="table-responsive-new">
                  <table class="table-new">
                    <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                  </table>
                  <div class="alert alert-warning mt-3 mb-0" role="alert">
                    @if (loading) {
                      <fa-icon class="me-1" [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin"></fa-icon>
                    }
                    @if (loading) {
                      <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
                    } @else {
                      <ng-container i18n="@@common.nothing_here">There's nothing here!</ng-container>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="grid-card-footer">
              @if (genAiModels?.getModels().length > 0) {
                <div>
                  <list-pagination
                    [totalItems]="genAiModels?.getMeta().meta.stats.total.count"
                    [filterComponent]="filterComponent"
                    [pageNumber]="listFilter.page.number"
                    [pageSize]="listFilter.page.size"
                  ></list-pagination>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
